module.exports = __webpack_public_path__ + "img/f19a9d9.jpg";